import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import _isObject from 'lodash/isObject';
import { DEFAULT_AUTO_SCROLL_INTERVAL, DEFAULT_SLIDE_DURATION_MS, MAX_INDICATORS_DISPLAY, MAX_INDICATORS_MOBILE_DISPLAY, SHOW_INDICATORS_THRESHOLD } from './constants';
import { toArray } from '../../../../../services/components';
import { classNames } from '../../../../../utils/classname';
export function getAutoScrollInterval(autoScroll, _ref) {
  var pageSize = _ref.pageSize,
    items = _ref.items;
  if (_isEmpty(items) || items.length <= pageSize) {
    return null;
  }
  if (!_isObject(autoScroll) && !autoScroll) {
    return null;
  }
  if (!_isObject(autoScroll) && autoScroll) {
    return DEFAULT_AUTO_SCROLL_INTERVAL;
  }
  return _get(autoScroll, 'interval', DEFAULT_AUTO_SCROLL_INTERVAL);
}
export function getPageSize(items, size, responsive) {
  var mobile = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _ref2 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
    isMobile = _ref2.isMobile,
    isTablet = _ref2.isTablet;
  var displayAllMobile = mobile.displayAll,
    mobileSize = mobile.size;
  var itemsArray = toArray(items);
  var itemsLength = itemsArray.length;
  if (isMobile) {
    if (!_isNil(mobileSize) && _isNumber(mobileSize)) {
      return Math.min(mobileSize, itemsLength);
    }
    if (displayAllMobile) {
      return itemsLength;
    }
  }
  if (responsive) {
    if (isMobile) {
      return displayAllMobile ? itemsLength : 1;
    }
    if (isTablet) {
      return Math.min(2, size, itemsLength);
    }
  }
  return Math.min(itemsLength, size);
}
export function canSafelyServerRender(items, size, responsive) {
  var mobile = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var desktopSize = getPageSize(items, size, responsive, mobile, {
    isDesktop: true
  });
  var tabletSize = getPageSize(items, size, responsive, mobile, {
    isTablet: true
  });
  var mobileSize = getPageSize(items, size, responsive, mobile, {
    isMobile: true
  });
  return mobileSize === tabletSize && tabletSize === desktopSize;
}
export function getStepSize(items, size, stepSize) {
  var grouping = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  if (_isNil(stepSize) && grouping === 1) {
    return null;
  }
  var itemsArray = toArray(items);
  var itemsLength = itemsArray.length;
  var pageSize = Math.min(size, itemsLength);
  if (_isNil(stepSize)) {
    return pageSize;
  }
  return Math.min(stepSize, pageSize);
}
export function showIndicators(pageSize, items) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref3$threshold = _ref3.threshold,
    threshold = _ref3$threshold === void 0 ? SHOW_INDICATORS_THRESHOLD : _ref3$threshold;
  var itemsArray = toArray(items);
  var itemsLength = itemsArray.length;
  return itemsLength / pageSize < threshold;
}
export function displayCarouselIndicators(pageSize, items) {
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    isMobile = _ref4.isMobile;
  var itemsArray = toArray(items);
  var itemsLength = itemsArray.length;
  var indicatorsToDisplay = itemsLength / pageSize;
  if (isMobile) {
    if (indicatorsToDisplay > MAX_INDICATORS_MOBILE_DISPLAY) {
      return false;
    }
  }
  if (indicatorsToDisplay > MAX_INDICATORS_DISPLAY) {
    return false;
  }
  return itemsLength > pageSize;
}
export function getElementKey() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = element.key,
    _element$props = element.props,
    props = _element$props === void 0 ? {} : _element$props;
  var _ref5 = props || {},
    children = _ref5.children;
  if (!_isEmpty(key)) {
    return key;
  }
  if (!_isEmpty(children)) {
    if (children.key) {
      return children.key;
    }
    if (_isArray(children)) {
      var childrenKey = children.map(function (_ref6) {
        var k = _ref6.key;
        return k;
      }).filter(Boolean);
      if (!_isEmpty(childrenKey)) {
        return childrenKey.join('_');
      }
    }
  }
  return JSON.stringify(element);
}
export function getSlidingCarouselElementStyle(_ref7) {
  var index = _ref7.index,
    activePage = _ref7.activePage,
    pageSize = _ref7.pageSize,
    stepSize = _ref7.stepSize,
    totalPages = _ref7.totalPages;
  var finalStepSize = Math.min(stepSize || pageSize, pageSize);
  var finalTotalPages = totalPages * finalStepSize;
  var currentPage = index + 1;
  function normalizeCarouselPage(page) {
    return (page - 1 + finalTotalPages) % finalTotalPages + 1;
  }
  function getSlidingPages(referencePage) {
    return Array.from({
      length: pageSize
    }, function (_, i) {
      return normalizeCarouselPage(referencePage + i);
    });
  }
  var finalActivePage = normalizeCarouselPage(activePage + (activePage - 1) * (finalStepSize - 1));
  var finalPreviousPage = normalizeCarouselPage(finalActivePage - pageSize);
  var finalNextPage = normalizeCarouselPage(finalActivePage + pageSize);
  var activePages = getSlidingPages(finalActivePage);
  var nextPages = getSlidingPages(finalNextPage);
  var previousPages = getSlidingPages(finalPreviousPage);
  var current = activePages.includes(currentPage);
  var next = nextPages.includes(currentPage) && !current;
  var previous = previousPages.includes(currentPage) && !current;
  var hidden = !current && !next && !previous;
  var active = !hidden;
  var first = current && activePages.indexOf(currentPage) === 0;
  var last = current && !first && activePages.indexOf(currentPage) === pageSize - 1;
  var className = classNames({
    'sliding-element': true,
    hidden: hidden,
    active: active,
    current: current,
    next: next,
    previous: previous,
    first: first,
    last: last
  });
  var offsetValue = -1;
  if (current) {
    offsetValue = activePages.indexOf(currentPage) * (1 / pageSize);
  } else if (previous) {
    offsetValue = previousPages.indexOf(currentPage) * (1 / pageSize) - 1;
  } else if (next) {
    offsetValue = nextPages.indexOf(currentPage) * (1 / pageSize) + 1;
  }
  var style = _objectSpread({
    height: 'fit-content',
    position: 'absolute',
    transition: "left ".concat(DEFAULT_SLIDE_DURATION_MS, "ms cubic-bezier(0.42, 0, 0.58, 1)"),
    top: '0%'
  }, hidden ? {
    visibility: 'hidden',
    opacity: 0
  } : {
    left: "".concat(offsetValue * 100, "%")
  });
  return {
    className: className,
    style: style
  };
}
export function getSlide(slide, isMobile, displayAllMobile) {
  if (isMobile && displayAllMobile) {
    return false;
  }
  return slide;
}